import { AbstractHistogram } from 'hdr-histogram-js'
import {
    allServiceReportsFromDailyReport,
    convertHistogramsDailyReport,
    DailyReport,
    mergeDailyReports,
} from '../../../domain/history/DailyReport'
import { aggregatedServiceReportKey, transactionReportKey } from '../../../domain/history/HistoryCriteria'
import { mergeServiceReports, ServiceReport } from '../../../domain/history/ServiceReport'
import { importHdrHistogram } from '../../../helper/importHdrHistogram'
import { FULFILLED } from '../action-helper'
import { FETCH_DAILY_REPORTS, FETCH_DAILY_REPORTS_TIME_EXPLORER, FETCH_DAILY_REPORTS_TRANSACTION } from './actions'
import { DailyReportState } from './DailyReportState'

const initialState: DailyReportState = {
    byDay: {},
    aggregated: {},
    transactions: {},
    timeExplorer: {},
    loaded: false,
}

export const dailyReportReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case FULFILLED(FETCH_DAILY_REPORTS): {
            const { byDay, aggregated } = fetchDailyReports(action)

            return {
                ...state,
                byDay: {
                    ...state.byDay,
                    ...byDay,
                },
                aggregated: {
                    ...state.aggregated,
                    ...aggregated,
                },
                loaded: true,
            }
        }
        case FULFILLED(FETCH_DAILY_REPORTS_TIME_EXPLORER): {
            const { environment, service, data: timeExplorerReport } = action.payload

            const timeExplorer = {
                ...state.timeExplorer,
                [environment]: {
                    ...state.timeExplorer[environment],
                    [service]: timeExplorerReport,
                },
            }

            return {
                ...state,
                timeExplorer,
            }
        }
        case FULFILLED(FETCH_DAILY_REPORTS_TRANSACTION): {
            const { criteria, transactionId, data } = action.payload
            const key = transactionReportKey(criteria, transactionId)

            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    [key]: {
                        ...data,
                        histogram: importHdrHistogram(data.histogram),
                    },
                },
            }
        }
        default:
            return state
    }
}

const fetchDailyReports = (action: any) => {
    let serviceReports: Array<ServiceReport<AbstractHistogram>> = []
    const byDay = {}
    const { criteria, data } = action.payload

    Object.keys(data).map(day => {
        const report: DailyReport<AbstractHistogram> = convertHistogramsDailyReport(data[day])

        serviceReports = [...serviceReports, ...allServiceReportsFromDailyReport(report)]

        if (byDay[day] === undefined) {
            byDay[day] = report

            return
        }

        byDay[day] = mergeDailyReports([byDay[day], report])
    })

    const aggregatedKey = aggregatedServiceReportKey(criteria)
    const aggregated = { [aggregatedKey]: mergeServiceReports(serviceReports, criteria.date, criteria.granularity) }

    return { aggregated, byDay }
}
